import request from '@/util/request'
export function myprize(query) {
  return request({
    url: '/myprize.php',
    method: 'get',
    params: query
  })
}
export function check(query) {
  return request({
    url: '/check.php',
    method: 'get',
    params: query
  })
}
export function receive(query) {
  return request({
    url: '/receive.php',
    method: 'get',
    params: query
  })
}
export function question(query) {
  return request({
    url: '/question.php',
    method: 'get',
    params: query
  })
}

export function llmgaojian_chat(data) {
  return request({
    url: '/llmgaojian_chat',
    method: 'post',
    data: data
  })
}
